var cov_1gprdmkkyf = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Image/Image.tsx",
      hash = "5bf5ada159ac031cb756b3d6489320031477a6a6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Image/Image.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 21
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 20
        },
        end: {
          line: 25,
          column: 21
        }
      },
      "2": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 13
        }
      },
      "3": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 13
        }
      },
      "4": {
        start: {
          line: 28,
          column: 14
        },
        end: {
          line: 28,
          column: 15
        }
      },
      "5": {
        start: {
          line: 30,
          column: 21
        },
        end: {
          line: 30,
          column: 23
        }
      },
      "6": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 16
        }
      },
      "7": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "8": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 50
        }
      },
      "9": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 52
        }
      },
      "10": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 46
        }
      },
      "11": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 50
        }
      },
      "12": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 29
        }
      },
      "13": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 21
        }
      },
      "14": {
        start: {
          line: 66,
          column: 25
        },
        end: {
          line: 66,
          column: 35
        }
      },
      "15": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "16": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 23
        }
      },
      "17": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 32
        }
      },
      "18": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 28
        }
      },
      "19": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 21
        }
      },
      "20": {
        start: {
          line: 79,
          column: 20
        },
        end: {
          line: 79,
          column: 81
        }
      },
      "21": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 43
        }
      },
      "22": {
        start: {
          line: 80,
          column: 17
        },
        end: {
          line: 80,
          column: 43
        }
      },
      "23": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 14
        }
      },
      "24": {
        start: {
          line: 85,
          column: 26
        },
        end: {
          line: 85,
          column: 36
        }
      },
      "25": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 61
        }
      },
      "26": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 21
        }
      },
      "27": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 45
        }
      },
      "28": {
        start: {
          line: 94,
          column: 21
        },
        end: {
          line: 94,
          column: 45
        }
      },
      "29": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "30": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 25
        }
      },
      "31": {
        start: {
          line: 98,
          column: 28
        },
        end: {
          line: 98,
          column: 38
        }
      },
      "32": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 104,
          column: 8
        }
      },
      "33": {
        start: {
          line: 109,
          column: 20
        },
        end: {
          line: 109,
          column: 30
        }
      },
      "34": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "35": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 22
        }
      },
      "36": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 12
        }
      },
      "37": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 21
        }
      },
      "38": {
        start: {
          line: 116,
          column: 18
        },
        end: {
          line: 116,
          column: 36
        }
      },
      "39": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 55
        }
      },
      "40": {
        start: {
          line: 117,
          column: 25
        },
        end: {
          line: 117,
          column: 55
        }
      },
      "41": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 52
        }
      },
      "42": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 32
        }
      },
      "43": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 22
        }
      },
      "44": {
        start: {
          line: 124,
          column: 24
        },
        end: {
          line: 124,
          column: 34
        }
      },
      "45": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 33
        }
      },
      "46": {
        start: {
          line: 125,
          column: 17
        },
        end: {
          line: 125,
          column: 33
        }
      },
      "47": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 127,
          column: 59
        }
      },
      "48": {
        start: {
          line: 126,
          column: 22
        },
        end: {
          line: 126,
          column: 38
        }
      },
      "49": {
        start: {
          line: 127,
          column: 9
        },
        end: {
          line: 127,
          column: 59
        }
      },
      "50": {
        start: {
          line: 127,
          column: 27
        },
        end: {
          line: 127,
          column: 59
        }
      },
      "51": {
        start: {
          line: 131,
          column: 20
        },
        end: {
          line: 131,
          column: 30
        }
      },
      "52": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "53": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 38
        }
      },
      "54": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 12
        }
      },
      "55": {
        start: {
          line: 137,
          column: 18
        },
        end: {
          line: 137,
          column: 36
        }
      },
      "56": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 55
        }
      },
      "57": {
        start: {
          line: 138,
          column: 25
        },
        end: {
          line: 138,
          column: 55
        }
      },
      "58": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 52
        }
      },
      "59": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 32
        }
      },
      "60": {
        start: {
          line: 144,
          column: 43
        },
        end: {
          line: 144,
          column: 53
        }
      },
      "61": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      },
      "62": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 16
        }
      },
      "63": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 12
        }
      },
      "64": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 152,
          column: 5
        }
      },
      "65": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 24
        }
      },
      "66": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 63
        }
      },
      "67": {
        start: {
          line: 156,
          column: 46
        },
        end: {
          line: 156,
          column: 56
        }
      },
      "68": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 164,
          column: 5
        }
      },
      "69": {
        start: {
          line: 168,
          column: 35
        },
        end: {
          line: 168,
          column: 45
        }
      },
      "70": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 171,
          column: 5
        }
      },
      "71": {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 170,
          column: 69
        }
      },
      "72": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 179,
          column: 5
        }
      },
      "73": {
        start: {
          line: 183,
          column: 23
        },
        end: {
          line: 183,
          column: 33
        }
      },
      "74": {
        start: {
          line: 184,
          column: 39
        },
        end: {
          line: 184,
          column: 49
        }
      },
      "75": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 201,
          column: 5
        }
      },
      "76": {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 39
        }
      },
      "77": {
        start: {
          line: 190,
          column: 8
        },
        end: {
          line: 190,
          column: 35
        }
      },
      "78": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 35
        }
      },
      "79": {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 198,
          column: 9
        }
      },
      "80": {
        start: {
          line: 200,
          column: 8
        },
        end: {
          line: 200,
          column: 19
        }
      },
      "81": {
        start: {
          line: 205,
          column: 63
        },
        end: {
          line: 205,
          column: 73
        }
      },
      "82": {
        start: {
          line: 207,
          column: 22
        },
        end: {
          line: 207,
          column: 83
        }
      },
      "83": {
        start: {
          line: 209,
          column: 16
        },
        end: {
          line: 209,
          column: 34
        }
      },
      "84": {
        start: {
          line: 211,
          column: 18
        },
        end: {
          line: 219,
          column: 5
        }
      },
      "85": {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 93
        }
      },
      "86": {
        start: {
          line: 220,
          column: 38
        },
        end: {
          line: 220,
          column: 93
        }
      },
      "87": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 221,
          column: 53
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        loc: {
          start: {
            line: 47,
            column: 33
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 47
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 22
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 60
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 44
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 65
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        loc: {
          start: {
            line: 72,
            column: 25
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 72
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        loc: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 78
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 84
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 38
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 89
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 15
          },
          end: {
            line: 106,
            column: 3
          }
        },
        line: 93
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        loc: {
          start: {
            line: 108,
            column: 17
          },
          end: {
            line: 121,
            column: 3
          }
        },
        line: 108
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 117,
            column: 19
          },
          end: {
            line: 117,
            column: 20
          }
        },
        loc: {
          start: {
            line: 117,
            column: 25
          },
          end: {
            line: 117,
            column: 55
          }
        },
        line: 117
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        },
        loc: {
          start: {
            line: 123,
            column: 38
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 123
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 14
          },
          end: {
            line: 141,
            column: 3
          }
        },
        line: 130
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 138,
            column: 19
          },
          end: {
            line: 138,
            column: 20
          }
        },
        loc: {
          start: {
            line: 138,
            column: 25
          },
          end: {
            line: 138,
            column: 55
          }
        },
        line: 138
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 143,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        loc: {
          start: {
            line: 143,
            column: 35
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 143
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 27
          },
          end: {
            line: 165,
            column: 3
          }
        },
        line: 155
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 167,
            column: 2
          },
          end: {
            line: 167,
            column: 3
          }
        },
        loc: {
          start: {
            line: 167,
            column: 22
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 167
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 16
          },
          end: {
            line: 202,
            column: 3
          }
        },
        line: 182
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 204,
            column: 2
          },
          end: {
            line: 204,
            column: 3
          }
        },
        loc: {
          start: {
            line: 204,
            column: 11
          },
          end: {
            line: 222,
            column: 3
          }
        },
        line: 204
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }],
        line: 67
      },
      "1": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 29
          }
        }, {
          start: {
            line: 67,
            column: 33
          },
          end: {
            line: 67,
            column: 54
          }
        }],
        line: 67
      },
      "2": {
        loc: {
          start: {
            line: 79,
            column: 20
          },
          end: {
            line: 79,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 46
          },
          end: {
            line: 79,
            column: 64
          }
        }, {
          start: {
            line: 79,
            column: 67
          },
          end: {
            line: 79,
            column: 81
          }
        }],
        line: 79
      },
      "3": {
        loc: {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 43
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 43
          }
        }],
        line: 80
      },
      "4": {
        loc: {
          start: {
            line: 86,
            column: 35
          },
          end: {
            line: 86,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 35
          },
          end: {
            line: 86,
            column: 39
          }
        }, {
          start: {
            line: 86,
            column: 43
          },
          end: {
            line: 86,
            column: 46
          }
        }],
        line: 86
      },
      "5": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 45
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 45
          }
        }],
        line: 94
      },
      "6": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }],
        line: 95
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 16
          },
          end: {
            line: 100,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 54
          },
          end: {
            line: 100,
            column: 69
          }
        }, {
          start: {
            line: 100,
            column: 72
          },
          end: {
            line: 100,
            column: 73
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 103,
            column: 19
          },
          end: {
            line: 103,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 103,
            column: 51
          },
          end: {
            line: 103,
            column: 84
          }
        }, {
          start: {
            line: 103,
            column: 87
          },
          end: {
            line: 103,
            column: 96
          }
        }],
        line: 103
      },
      "9": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }],
        line: 110
      },
      "10": {
        loc: {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 33
          }
        }, {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 33
          }
        }],
        line: 125
      },
      "11": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 127,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 127,
            column: 59
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 127,
            column: 59
          }
        }],
        line: 126
      },
      "12": {
        loc: {
          start: {
            line: 127,
            column: 9
          },
          end: {
            line: 127,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 9
          },
          end: {
            line: 127,
            column: 59
          }
        }, {
          start: {
            line: 127,
            column: 9
          },
          end: {
            line: 127,
            column: 59
          }
        }],
        line: 127
      },
      "13": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 132
      },
      "14": {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }],
        line: 145
      },
      "15": {
        loc: {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }, {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }],
        line: 149
      },
      "16": {
        loc: {
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 149,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 149,
            column: 12
          }
        }, {
          start: {
            line: 149,
            column: 16
          },
          end: {
            line: 149,
            column: 35
          }
        }],
        line: 149
      },
      "17": {
        loc: {
          start: {
            line: 151,
            column: 37
          },
          end: {
            line: 151,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 151,
            column: 37
          },
          end: {
            line: 151,
            column: 41
          }
        }, {
          start: {
            line: 151,
            column: 45
          },
          end: {
            line: 151,
            column: 48
          }
        }],
        line: 151
      },
      "18": {
        loc: {
          start: {
            line: 156,
            column: 24
          },
          end: {
            line: 156,
            column: 41
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 156,
            column: 36
          },
          end: {
            line: 156,
            column: 41
          }
        }],
        line: 156
      },
      "19": {
        loc: {
          start: {
            line: 158,
            column: 11
          },
          end: {
            line: 164,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 159,
            column: 104
          }
        }, {
          start: {
            line: 161,
            column: 6
          },
          end: {
            line: 163,
            column: 12
          }
        }],
        line: 158
      },
      "20": {
        loc: {
          start: {
            line: 158,
            column: 11
          },
          end: {
            line: 158,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 11
          },
          end: {
            line: 158,
            column: 25
          }
        }, {
          start: {
            line: 158,
            column: 29
          },
          end: {
            line: 158,
            column: 42
          }
        }],
        line: 158
      },
      "21": {
        loc: {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 171,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 171,
            column: 5
          }
        }, {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 171,
            column: 5
          }
        }],
        line: 169
      },
      "22": {
        loc: {
          start: {
            line: 176,
            column: 55
          },
          end: {
            line: 176,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 176,
            column: 55
          },
          end: {
            line: 176,
            column: 66
          }
        }, {
          start: {
            line: 176,
            column: 70
          },
          end: {
            line: 176,
            column: 90
          }
        }],
        line: 176
      },
      "23": {
        loc: {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 201,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 187,
            column: 6
          },
          end: {
            line: 188,
            column: 39
          }
        }, {
          start: {
            line: 189,
            column: 6
          },
          end: {
            line: 190,
            column: 35
          }
        }, {
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 192,
            column: 35
          }
        }, {
          start: {
            line: 193,
            column: 6
          },
          end: {
            line: 198,
            column: 9
          }
        }, {
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 200,
            column: 19
          }
        }],
        line: 186
      },
      "24": {
        loc: {
          start: {
            line: 196,
            column: 18
          },
          end: {
            line: 196,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 196,
            column: 18
          },
          end: {
            line: 196,
            column: 23
          }
        }, {
          start: {
            line: 196,
            column: 27
          },
          end: {
            line: 196,
            column: 32
          }
        }, {
          start: {
            line: 196,
            column: 36
          },
          end: {
            line: 196,
            column: 57
          }
        }],
        line: 196
      },
      "25": {
        loc: {
          start: {
            line: 209,
            column: 16
          },
          end: {
            line: 209,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 209,
            column: 23
          },
          end: {
            line: 209,
            column: 26
          }
        }, {
          start: {
            line: 209,
            column: 29
          },
          end: {
            line: 209,
            column: 34
          }
        }],
        line: 209
      },
      "26": {
        loc: {
          start: {
            line: 214,
            column: 14
          },
          end: {
            line: 214,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 214,
            column: 39
          },
          end: {
            line: 214,
            column: 46
          }
        }, {
          start: {
            line: 214,
            column: 49
          },
          end: {
            line: 214,
            column: 55
          }
        }],
        line: 214
      },
      "27": {
        loc: {
          start: {
            line: 220,
            column: 4
          },
          end: {
            line: 220,
            column: 93
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 220,
            column: 4
          },
          end: {
            line: 220,
            column: 93
          }
        }, {
          start: {
            line: 220,
            column: 4
          },
          end: {
            line: 220,
            column: 93
          }
        }],
        line: 220
      },
      "28": {
        loc: {
          start: {
            line: 220,
            column: 8
          },
          end: {
            line: 220,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 220,
            column: 8
          },
          end: {
            line: 220,
            column: 13
          }
        }, {
          start: {
            line: 220,
            column: 17
          },
          end: {
            line: 220,
            column: 36
          }
        }],
        line: 220
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0, 0, 0, 0],
      "24": [0, 0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Image/Image.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { addStack, removeStack } from '../utils/lazyload';
import { imageClass } from './styles';
import showGallery from './events';
import { getLocale } from '../locale';
import config from '../config';
import { removeProtocol } from '../utils/strings';
import getDataset from '../utils/dom/getDataset';
var DefaultProps = (cov_1gprdmkkyf.s[0]++, {
  lazy: false,
  target: '_modal',
  width: '100%',
  height: '100%'
});
var PLACEHOLDER = (cov_1gprdmkkyf.s[1]++, 0);
var SRC = (cov_1gprdmkkyf.s[2]++, 1);
var ALT = (cov_1gprdmkkyf.s[3]++, 2);
var ERROR = (cov_1gprdmkkyf.s[4]++, 3);
export var IMAGE = (cov_1gprdmkkyf.s[5]++, {});

var Image =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Image, _PureComponent);

  var _super = _createSuper2(Image);

  function Image(props) {
    var _this;

    _classCallCheck(this, Image);

    cov_1gprdmkkyf.f[0]++;
    cov_1gprdmkkyf.s[6]++;
    _this = _super.call(this, props);
    _this.lazyId = void 0;
    _this.image = void 0;
    _this.element = void 0;
    cov_1gprdmkkyf.s[7]++;
    _this.state = {
      status: PLACEHOLDER
    };
    cov_1gprdmkkyf.s[8]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_1gprdmkkyf.s[9]++;
    _this.markToRender = _this.markToRender.bind(_assertThisInitialized(_this));
    cov_1gprdmkkyf.s[10]++;
    _this.handleAlt = _this.handleAlt.bind(_assertThisInitialized(_this));
    cov_1gprdmkkyf.s[11]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1gprdmkkyf.f[1]++;
      cov_1gprdmkkyf.s[12]++;

      _get(_getPrototypeOf(Image.prototype), "componentDidMount", this).call(this);

      cov_1gprdmkkyf.s[13]++;
      this.fetchImage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_1gprdmkkyf.f[2]++;

      var _ref = (cov_1gprdmkkyf.s[14]++, this.props),
          src = _ref.src,
          alt = _ref.alt;

      cov_1gprdmkkyf.s[15]++;

      if ((cov_1gprdmkkyf.b[1][0]++, prevProps.src !== src) || (cov_1gprdmkkyf.b[1][1]++, prevProps.alt !== alt)) {
        cov_1gprdmkkyf.b[0][0]++;
        cov_1gprdmkkyf.s[16]++;
        this.fetchImage();
      } else {
        cov_1gprdmkkyf.b[0][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1gprdmkkyf.f[3]++;
      cov_1gprdmkkyf.s[17]++;

      _get(_getPrototypeOf(Image.prototype), "componentWillUnmount", this).call(this);

      cov_1gprdmkkyf.s[18]++;
      removeStack(this.lazyId);
      cov_1gprdmkkyf.s[19]++;
      delete this.image;
    }
  }, {
    key: "getUrl",
    value: function getUrl(url) {
      cov_1gprdmkkyf.f[4]++;
      var autoSSL = (cov_1gprdmkkyf.s[20]++, 'autoSSL' in this.props ? (cov_1gprdmkkyf.b[2][0]++, this.props.autoSSL) : (cov_1gprdmkkyf.b[2][1]++, config.autoSSL));
      cov_1gprdmkkyf.s[21]++;

      if (autoSSL) {
        cov_1gprdmkkyf.b[3][0]++;
        cov_1gprdmkkyf.s[22]++;
        return removeProtocol(url);
      } else {
        cov_1gprdmkkyf.b[3][1]++;
      }

      cov_1gprdmkkyf.s[23]++;
      return url;
    }
  }, {
    key: "preview",
    value: function preview() {
      cov_1gprdmkkyf.f[5]++;

      var _ref2 = (cov_1gprdmkkyf.s[24]++, this.props),
          src = _ref2.src,
          href = _ref2.href;

      cov_1gprdmkkyf.s[25]++;
      showGallery({
        thumb: src,
        src: (cov_1gprdmkkyf.b[4][0]++, href) || (cov_1gprdmkkyf.b[4][1]++, src),
        key: 'key'
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1gprdmkkyf.f[6]++;
      cov_1gprdmkkyf.s[26]++;
      this.element = el;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage() {
      cov_1gprdmkkyf.f[7]++;
      cov_1gprdmkkyf.s[27]++;

      if (this.lazyId) {
        cov_1gprdmkkyf.b[5][0]++;
        cov_1gprdmkkyf.s[28]++;
        removeStack(this.lazyId);
      } else {
        cov_1gprdmkkyf.b[5][1]++;
      }

      cov_1gprdmkkyf.s[29]++;

      if (!this.props.lazy) {
        cov_1gprdmkkyf.b[6][0]++;
        cov_1gprdmkkyf.s[30]++;
        this.markToRender();
      } else {
        cov_1gprdmkkyf.b[6][1]++;

        var _ref3 = (cov_1gprdmkkyf.s[31]++, this.props),
            container = _ref3.container;

        cov_1gprdmkkyf.s[32]++;
        this.lazyId = addStack({
          offset: typeof this.props.lazy === 'number' ? (cov_1gprdmkkyf.b[7][0]++, this.props.lazy) : (cov_1gprdmkkyf.b[7][1]++, 0),
          element: this.element,
          render: this.markToRender,
          container: typeof container === 'string' ? (cov_1gprdmkkyf.b[8][0]++, document.querySelector(container)) : (cov_1gprdmkkyf.b[8][1]++, container)
        });
      }
    }
  }, {
    key: "markToRender",
    value: function markToRender() {
      var _this2 = this;

      cov_1gprdmkkyf.f[8]++;

      var _ref4 = (cov_1gprdmkkyf.s[33]++, this.props),
          src = _ref4.src;

      cov_1gprdmkkyf.s[34]++;

      if (!src) {
        cov_1gprdmkkyf.b[9][0]++;
        cov_1gprdmkkyf.s[35]++;
        this.handleAlt();
        cov_1gprdmkkyf.s[36]++;
        return;
      } else {
        cov_1gprdmkkyf.b[9][1]++;
      }

      cov_1gprdmkkyf.s[37]++;
      delete this.image;
      var image = (cov_1gprdmkkyf.s[38]++, new window.Image());
      cov_1gprdmkkyf.s[39]++;

      image.onload = function () {
        cov_1gprdmkkyf.f[9]++;
        cov_1gprdmkkyf.s[40]++;
        return _this2.setState({
          status: SRC
        });
      };

      cov_1gprdmkkyf.s[41]++;
      image.onerror = this.handleError.bind(this, SRC);
      cov_1gprdmkkyf.s[42]++;
      image.src = this.getUrl(src);
      cov_1gprdmkkyf.s[43]++;
      this.image = image;
    }
  }, {
    key: "handleError",
    value: function handleError(type, e) {
      cov_1gprdmkkyf.f[10]++;

      var _ref5 = (cov_1gprdmkkyf.s[44]++, this.props),
          onError = _ref5.onError;

      cov_1gprdmkkyf.s[45]++;

      if (onError) {
        cov_1gprdmkkyf.b[10][0]++;
        cov_1gprdmkkyf.s[46]++;
        onError(e, type);
      } else {
        cov_1gprdmkkyf.b[10][1]++;
      }

      cov_1gprdmkkyf.s[47]++;

      if (type === SRC) {
        cov_1gprdmkkyf.b[11][0]++;
        cov_1gprdmkkyf.s[48]++;
        this.handleAlt();
      } else {
        cov_1gprdmkkyf.b[11][1]++;
        cov_1gprdmkkyf.s[49]++;

        if (type === ALT) {
          cov_1gprdmkkyf.b[12][0]++;
          cov_1gprdmkkyf.s[50]++;
          this.setState({
            status: ERROR
          });
        } else {
          cov_1gprdmkkyf.b[12][1]++;
        }
      }
    }
  }, {
    key: "handleAlt",
    value: function handleAlt() {
      var _this3 = this;

      cov_1gprdmkkyf.f[11]++;

      var _ref6 = (cov_1gprdmkkyf.s[51]++, this.props),
          alt = _ref6.alt;

      cov_1gprdmkkyf.s[52]++;

      if (!alt) {
        cov_1gprdmkkyf.b[13][0]++;
        cov_1gprdmkkyf.s[53]++;
        this.setState({
          status: ERROR
        });
        cov_1gprdmkkyf.s[54]++;
        return;
      } else {
        cov_1gprdmkkyf.b[13][1]++;
      }

      var image = (cov_1gprdmkkyf.s[55]++, new window.Image());
      cov_1gprdmkkyf.s[56]++;

      image.onload = function () {
        cov_1gprdmkkyf.f[12]++;
        cov_1gprdmkkyf.s[57]++;
        return _this3.setState({
          status: ALT
        });
      };

      cov_1gprdmkkyf.s[58]++;
      image.onerror = this.handleError.bind(this, ALT);
      cov_1gprdmkkyf.s[59]++;
      image.src = this.getUrl(alt);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      cov_1gprdmkkyf.f[13]++;

      var _ref7 = (cov_1gprdmkkyf.s[60]++, this.props),
          onClick = _ref7.onClick,
          target = _ref7.target,
          src = _ref7.src,
          href = _ref7.href;

      cov_1gprdmkkyf.s[61]++;

      if (onClick) {
        cov_1gprdmkkyf.b[14][0]++;
        cov_1gprdmkkyf.s[62]++;
        onClick(e);
        cov_1gprdmkkyf.s[63]++;
        return;
      } else {
        cov_1gprdmkkyf.b[14][1]++;
      }

      cov_1gprdmkkyf.s[64]++;

      if ((cov_1gprdmkkyf.b[16][0]++, href) && (cov_1gprdmkkyf.b[16][1]++, target === '_modal')) {
        cov_1gprdmkkyf.b[15][0]++;
        cov_1gprdmkkyf.s[65]++;
        e.preventDefault();
        cov_1gprdmkkyf.s[66]++;
        showGallery({
          thumb: src,
          src: (cov_1gprdmkkyf.b[17][0]++, href) || (cov_1gprdmkkyf.b[17][1]++, src),
          key: 'key'
        });
      } else {
        cov_1gprdmkkyf.b[15][1]++;
      }
    }
  }, {
    key: "renderType",
    value: function renderType(src) {
      cov_1gprdmkkyf.f[14]++;

      var _ref8 = (cov_1gprdmkkyf.s[67]++, this.props),
          title = _ref8.title,
          fit = _ref8.fit,
          _ref8$noImgDrag = _ref8.noImgDrag,
          noImgDrag = _ref8$noImgDrag === void 0 ? (cov_1gprdmkkyf.b[18][0]++, false) : _ref8$noImgDrag;

      cov_1gprdmkkyf.s[68]++;
      return (cov_1gprdmkkyf.b[20][0]++, fit === 'fill') || (cov_1gprdmkkyf.b[20][1]++, fit === 'fit') ? (cov_1gprdmkkyf.b[19][0]++,
      /*#__PURE__*/
      React.createElement("div", {
        className: imageClass('inner'),
        title: title,
        style: {
          backgroundImage: "url(\"".concat(src, "\")")
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159,
          columnNumber: 7
        }
      })) : (cov_1gprdmkkyf.b[19][1]++,
      /*#__PURE__*/
      React.createElement("div", {
        className: imageClass('inner'),
        title: title,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 7
        }
      },
      /*#__PURE__*/
      React.createElement("img", {
        alt: "",
        src: src,
        draggable: !noImgDrag,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162,
          columnNumber: 9
        }
      })));
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      cov_1gprdmkkyf.f[15]++;

      var _ref9 = (cov_1gprdmkkyf.s[69]++, this.props),
          placeholder = _ref9.placeholder,
          title = _ref9.title;

      cov_1gprdmkkyf.s[70]++;

      if (
      /*#__PURE__*/
      React.isValidElement(placeholder)) {
        cov_1gprdmkkyf.b[21][0]++;
        cov_1gprdmkkyf.s[71]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: imageClass('inner'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 170,
              columnNumber: 14
            }
          }, placeholder)
        );
      } else {
        cov_1gprdmkkyf.b[21][1]++;
      }

      cov_1gprdmkkyf.s[72]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: imageClass('inner', 'mask'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 173,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 174,
            columnNumber: 9
          }
        }, title,
        /*#__PURE__*/
        React.createElement("span", {
          className: imageClass('placeholder'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 176,
            columnNumber: 11
          }
        }, (cov_1gprdmkkyf.b[22][0]++, placeholder) || (cov_1gprdmkkyf.b[22][1]++, getLocale('loading')))))
      );
    }
  }, {
    key: "renderImage",
    value: function renderImage() {
      cov_1gprdmkkyf.f[16]++;

      var _ref10 = (cov_1gprdmkkyf.s[73]++, this.state),
          status = _ref10.status;

      var _ref11 = (cov_1gprdmkkyf.s[74]++, this.props),
          alt = _ref11.alt,
          src = _ref11.src,
          title = _ref11.title,
          error = _ref11.error;

      cov_1gprdmkkyf.s[75]++;

      switch (status) {
        case PLACEHOLDER:
          cov_1gprdmkkyf.b[23][0]++;
          cov_1gprdmkkyf.s[76]++;
          return this.renderPlaceholder();

        case SRC:
          cov_1gprdmkkyf.b[23][1]++;
          cov_1gprdmkkyf.s[77]++;
          return this.renderType(src);

        case ALT:
          cov_1gprdmkkyf.b[23][2]++;
          cov_1gprdmkkyf.s[78]++;
          return this.renderType(alt);

        case ERROR:
          cov_1gprdmkkyf.b[23][3]++;
          cov_1gprdmkkyf.s[79]++;
          return (
            /*#__PURE__*/
            React.createElement("div", {
              className: imageClass('inner', 'mask'),
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 195,
                columnNumber: 11
              }
            },
            /*#__PURE__*/
            React.createElement("div", {
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 196,
                columnNumber: 13
              }
            }, (cov_1gprdmkkyf.b[24][0]++, error) || (cov_1gprdmkkyf.b[24][1]++, title) || (cov_1gprdmkkyf.b[24][2]++, getLocale('notFound'))))
          );

        default:
          cov_1gprdmkkyf.b[23][4]++;
          cov_1gprdmkkyf.s[80]++;
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1gprdmkkyf.f[17]++;

      var _ref12 = (cov_1gprdmkkyf.s[81]++, this.props),
          href = _ref12.href,
          height = _ref12.height,
          style = _ref12.style,
          shape = _ref12.shape,
          fit = _ref12.fit,
          width = _ref12.width,
          target = _ref12.target;

      var className = (cov_1gprdmkkyf.s[82]++, classnames(imageClass('_', shape, fit), this.props.className));
      var Tag = (cov_1gprdmkkyf.s[83]++, href ? (cov_1gprdmkkyf.b[25][0]++, 'a') : (cov_1gprdmkkyf.b[25][1]++, 'div'));
      var props = (cov_1gprdmkkyf.s[84]++, _objectSpread2({
        ref: this.bindElement,
        onClick: this.handleClick,
        target: target === '_download' ? (cov_1gprdmkkyf.b[26][0]++, '_self') : (cov_1gprdmkkyf.b[26][1]++, target),
        download: target === '_download',
        className: className,
        style: Object.assign({}, style, {
          width: width,
          paddingBottom: height
        })
      }, getDataset(this.props)));
      cov_1gprdmkkyf.s[85]++;

      if ((cov_1gprdmkkyf.b[28][0]++, !href) || (cov_1gprdmkkyf.b[28][1]++, target !== '_modal')) {
        cov_1gprdmkkyf.b[27][0]++;
        cov_1gprdmkkyf.s[86]++;
        props.href = href;
      } else {
        cov_1gprdmkkyf.b[27][1]++;
      }

      cov_1gprdmkkyf.s[87]++;
      return (
        /*#__PURE__*/
        React.createElement(Tag, Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 221,
            columnNumber: 12
          }
        }), this.renderImage())
      );
    }
  }]);

  return Image;
}(PureComponent);

Image.symbolType = IMAGE;
Image.defaultProps = DefaultProps;
Image.displayName = void 0;
Image.Group = void 0;
export { Image as default };